import { render, staticRenderFns } from "./StarIcon.vue?vue&type=template&id=623cd8e9&scoped=true&"
var script = {}
import style0 from "./StarIcon.vue?vue&type=style&index=0&id=623cd8e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623cd8e9",
  null
  
)

export default component.exports